import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-leadership',
  templateUrl: './leadership.component.html',
  styleUrls: ['./leadership.component.scss']
})
export class LeadershipComponent implements OnInit, OnDestroy {
  LeadershipInfo: any[] = [];
  fetchinData = true;
  private ngUnsubscribe = new Subject();

  constructor(private appService: AppService, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.FetchLeadershipInfo();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchLeadershipInfo() {
    this.fetchinData = true;
    forkJoin([
      this.appService.getGBs(),
    ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      const allData = Array.isArray(response[0].data) ? response[0].data : [];
      this.LeadershipInfo = allData.filter((x: any) => {
        const gbDesig = (x.GBDesignation || x.gbDesignation || x.GbDesignation || '').toString().trim().toLowerCase();
        return gbDesig === 'leadership';
      });
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }
}
